import { ApolloClient, type NormalizedCacheObject } from '@apollo/client';

import { query } from '@/helpers/api/graphql/apollo-server-only-instance';
import { isServerSide } from '@/helpers/isServerSide';

import makeApolloClient from './makeApolloClient';

let apolloClient: ApolloClient<NormalizedCacheObject>;

const getApolloClient = () => {
  if (isServerSide()) {
    return { query }; //TODO: getClient()
  }

  if (!apolloClient) apolloClient = makeApolloClient();
  return apolloClient;
};

export default getApolloClient;
